/**
 * Four-point star with a small accent star, used to mark AI-assisted surfaces
 * (extraction badges, the "Search or ask Bill" field). Filled glyph; decorative,
 * so it is always `aria-hidden` and the caller names the control around it.
 */
export function SparkleIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      {/* Bold 4-pointed star with concave sides (fat arms read clearly at small sizes). */}
      <path
        d="M8 0.5 Q9.1 6.9 15.5 8 Q9.1 9.1 8 15.5 Q6.9 9.1 0.5 8 Q6.9 6.9 8 0.5 Z"
        fill="currentColor"
      />
      {/* One small accent sparkle, top-right. */}
      <path
        d="M13 1.5 Q13.4 3.6 15.5 4 Q13.4 4.4 13 6.5 Q12.6 4.4 10.5 4 Q12.6 3.6 13 1.5 Z"
        fill="currentColor"
        opacity="0.8"
      />
    </svg>
  );
}
